import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ThinAddIcon, ThinEditIcon, ThinTrashIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat} from "../../../components/techaran/money";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AddEditJobModal} from "./add-edit-job";

interface jobInterface {
    id: number,
    title: string,
    isTeacher: boolean,
    count: number,
}

export const AdminsStaffJobsScreen = () => {
    const [list, setList] = useState<jobInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/jobs/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: jobInterface[] | null
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاغل | منابع انسانی | اتوماسیون";
        fetchList();
    }, []);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        title: '',
        id: 0,
    });
    const [addEdit, setAddEdit] = useState({
        show: false,
        edit: false,
        title: '',
        isTeacher: false,
        id: 0,
    });
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/jobs', title: 'مدیریت مشاغل'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>مشاغل</b>
                                <button onClick={() => setAddEdit({
                                    show: true,
                                    id: 0,
                                    title: '',
                                    isTeacher: false,
                                    edit: false,
                                })}>
                                    <ThinAddIcon/>
                                    <span>شغل جدید</span>
                                </button>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>معلم</th>
                                    <th>تعداد افراد</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"Hru238DD92SDD_" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>{s.title}</td>
                                            <td>{s.isTeacher ? 'بله' : 'خیر'}</td>
                                            <td>{CurrencyFormat(s.count)} نفر</td>
                                            <td>
                                                <div className="d-inline-flex align-items-center" style={{gap: 5}}>
                                                    <button className="open-tooltip" onClick={() => setRemoveModal({
                                                        title: s.title,
                                                        show: true,
                                                        id: s.id,
                                                    })}>
                                                        <i>حذف</i>
                                                        <ThinTrashIcon/>
                                                    </button>
                                                    <button className="open-tooltip" onClick={() => setAddEdit({
                                                        title: s.title,
                                                        show: true,
                                                        id: s.id,
                                                        edit: true,
                                                        isTeacher: s.isTeacher,
                                                    })}>
                                                        <i>ویرایش</i>
                                                        <ThinEditIcon/>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AddEditJobModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                edit={addEdit.edit}
                title={addEdit.title}
                isTeacher={addEdit.isTeacher}
                id={addEdit.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف شغل"}
                desc={`آیا مطمئن هستید می‌خواهید شغل ${removeModal.title} را حذف کنید؟`}
                onRemove={() => {
                    ShowProgressLoading();
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/jobs/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'شغل حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};